const FONTS_FOLDER =
  "/etc.clientlibs/capital-group/clientlibs/clientlib-site/resources/fonts/avenir-next/";

export enum AvenirNextFont {
  Bold = "AvenirNextLTCom-Bold",
  Demi = "AvenirNextLTCom-Demi",
  DemiIt = "AvenirNextLTCom-DemiIt",
  Regular = "AvenirNextLTCom-Regular",
}

export const AvenirNextLTComBold = {
  fontDisplay: "swap",
  fontFamily: AvenirNextFont.Bold,
  fontStretch: "normal",
  fontStyle: "normal",
  fontWeight: "normal",
  src: `
    url("${FONTS_FOLDER}/${AvenirNextFont.Bold}.woff2") format("woff2");
    url("${FONTS_FOLDER}/${AvenirNextFont.Bold}.woff") format("woff");
    url("${FONTS_FOLDER}/${AvenirNextFont.Bold}.ttf") format("truetype");
    url("${FONTS_FOLDER}/${AvenirNextFont.Bold}.eot") format("embedded-opentype");
    url("${FONTS_FOLDER}/${AvenirNextFont.Bold}.eot?#iefix") format("embedded-opentype")
`,
};

export const AvenirNextLTComDemi = {
  fontDisplay: "swap",
  fontFamily: AvenirNextFont.Demi,
  fontStretch: "normal",
  fontStyle: "normal",
  fontWeight: "normal",
  src: `
    url("${FONTS_FOLDER}/${AvenirNextFont.Demi}.woff2") format("woff2");
    url("${FONTS_FOLDER}/${AvenirNextFont.Demi}.woff") format("woff");
    url("${FONTS_FOLDER}/${AvenirNextFont.Demi}.ttf") format("truetype");
    url("${FONTS_FOLDER}/${AvenirNextFont.Demi}.eot") format("embedded-opentype");
    url("${FONTS_FOLDER}/${AvenirNextFont.Demi}.eot?#iefix") format("embedded-opentype")
`,
};

export const AvenirNextLTComDemiIt = {
  fontDisplay: "swap",
  fontFamily: AvenirNextFont.DemiIt,
  fontStretch: "normal",
  fontStyle: "normal",
  fontWeight: "normal",
  src: `
    url("${FONTS_FOLDER}/${AvenirNextFont.DemiIt}.woff2") format("woff2");
    url("${FONTS_FOLDER}/${AvenirNextFont.DemiIt}.woff") format("woff");
    url("${FONTS_FOLDER}/${AvenirNextFont.DemiIt}.ttf") format("truetype");
    url("${FONTS_FOLDER}/${AvenirNextFont.DemiIt}.eot") format("embedded-opentype");
    url("${FONTS_FOLDER}/${AvenirNextFont.DemiIt}.eot?#iefix") format("embedded-opentype")
`,
};

export const AvenirNextLTComRegular = {
  fontDisplay: "swap",
  fontFamily: AvenirNextFont.Regular,
  fontStretch: "normal",
  fontStyle: "normal",
  fontWeight: "normal",
  src: `
    url("${FONTS_FOLDER}/${AvenirNextFont.Regular}.woff2") format("woff2");
    url("${FONTS_FOLDER}/${AvenirNextFont.Regular}.woff") format("woff");
    url("${FONTS_FOLDER}/${AvenirNextFont.Regular}.ttf") format("truetype");
    url("${FONTS_FOLDER}/${AvenirNextFont.Regular}.eot") format("embedded-opentype");
    url("${FONTS_FOLDER}/${AvenirNextFont.Regular}.eot?#iefix") format("embedded-opentype")
`,
};

const fonts = {
  extraBold: `"${AvenirNextFont.Bold}", "Arial", sans-serif`,
  bold: `"${AvenirNextFont.Demi}", "Arial", sans-serif`,
  boldItalic: `"${AvenirNextFont.DemiIt}", "Arial", sans-serif`,
  regular: `"${AvenirNextFont.Regular}", "Arial", sans-serif`,
};

export type Fonts = typeof fonts;
export default fonts;
